import axios from 'axios';

import AppModel from 'Models/AppModel';
import TestGroup from './TestGroup.class';
import cookieControllerInstance from './cookieController';

const APIURLAddUser = (id) => `${AppModel.INTERNAL_URL}/api/shop/ab_tests/${id}/add_user`;

export default class ABTest {
  constructor(id, ...groups) {
    this.id = id;
    this.isTestActive = false;

    this.groups = groups;
    this.defaultGroup = null;

    this.groups.forEach((group) => {
      if (!(group instanceof TestGroup)) {
        console.error('[ABTest] Group is not instanceof TestGroup.class!');
        return;
      }

      if (group.groupId === 1) {
        this.defaultGroup = group;
      }

      group._setTestId(id);
    });

    if (!this.defaultGroup) {
      console.error('[ABTest] Default group is not declared!');
    }
  }

  get userGroup() {
    return this.isTestActive ? this.groups.find((group) => group.isActive) ?? this.defaultGroup : this.defaultGroup;
  }

  get isActive() {
    return this.isTestActive;
  }

  enable() {
    this.isTestActive = true;

    return this;
  }

  disable() {
    this.isTestActive = false;

    return this;
  }

  async addUserToTest(context) {
    if (cookieControllerInstance.getABCookieById(this.id)) {
      return false;
    }

    const response = await axios.post(APIURLAddUser(this.id)).catch((e) => e.response);

    if (context && response?.headers) {
      cookieControllerInstance.transferSSRCookies({
        headers: response.headers,
        setCookie: context._setCookie,
        ssrCookies: context.cookies,
      });
    }

    if (response?.data?.errors) {
      this.disable();
      return false;
    }

    return true;
  }
}
